export default __webpack_public_path__ + "static/media/tour-units.2d95ac1a.svg";